var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.464,
    height: 20.463,
    viewBox: "0 0 20.464 20.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#20bead;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M49.36,37.243H46.649V33.075a.875.875,0,1,0-1.749,0v5.043a.859.859,0,0,0,.875.875H49.36a.875.875,0,1,0,0-1.749Z",
    transform: "translate(-35.863 -27.419)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.132,15.8A10.232,10.232,0,1,0,34.364,26.032,10.227,10.227,0,0,0,24.132,15.8Zm0,18.715a8.483,8.483,0,1,1,8.483-8.483A8.51,8.51,0,0,1,24.132,34.515Z",
    transform: "translate(-13.9 -15.8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock_icon.cae44cb5f0f053069570352ac2f464e6.svg";
export { ForwardRef as ReactComponent };